import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-number-cell-editor',
    imports: [FormsModule],
    templateUrl: './number-cell-editor.component.html',
    styleUrl: './number-cell-editor.component.scss'
})
export class NumberCellEditorComponent implements ICellEditorAngularComp {
  private params: any;
  public value: any;

  agInit(params: any): void {
    this.params = params;
    this.value = params.value;
  }

  getValue(): any {
    return this.value ? this.value as number : null;
  }

  onKeyDown(event: KeyboardEvent): void {
    // Allow common controls like backspace, delete, arrows
    if (['Backspace','Delete','ArrowLeft','ArrowRight','Tab'].includes(event.key))
      return;

    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }
}
